import React from "react";
import AppTheme from "../../shared-theme/AppTheme";
import CssBaseline from "@mui/material/CssBaseline";
import ColorModeSelect from "../../shared-theme/ColorModeSelect";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import MuiCard from "@mui/material/Card";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { formHelperTextClasses, Grid, IconButton, InputAdornment, Snackbar } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { agentChangePassword } from "../../actions/agent";
import Copyright from "../../internals/components/Copyright";

const Card = styled(MuiCard)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	alignSelf: "center",
	width: "100%",
	padding: theme.spacing(4),
	gap: theme.spacing(2),
	margin: "auto",
	[theme.breakpoints.up("sm")]: {
		maxWidth: "450px",
	},
	boxShadow: "hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px",
	...theme.applyStyles("dark", {
		boxShadow: "hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px",
	}),
}));

const SignInContainer = styled(Stack)(({ theme }) => ({
	height: "calc((1 - var(--template-frame-height, 0)) * 100dvh)",
	minHeight: "100%",
	padding: theme.spacing(2),
	[theme.breakpoints.up("sm")]: {
		padding: theme.spacing(4),
	},
	"&::before": {
		content: '""',
		display: "block",
		position: "absolute",
		zIndex: -1,
		inset: 0,
		backgroundImage: "radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))",
		backgroundRepeat: "no-repeat",
		...theme.applyStyles("dark", {
			backgroundImage: "radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))",
		}),
	},
}));

const useStyles = makeStyles({
	snackbarStyleViaContentProps: {
		backgroundColor: "green",
	},
	snackbarStyleViaNestedContent: {
		backgroundColor: "lightgreen",
		color: "black",
	},
});

const ChangePassword = (props) => {
	const [actulPasswordError, setActualPasswordError] = React.useState(false);
	const [acutualPasswordErrorMessage, setActualPasswordErrorMessage] = React.useState("");
	const [confirmPasswordError, setConfirmPasswordError] = React.useState(false);
	const [confirmPasswordErrorMessage, setConfirmPasswordErrorMessage] = React.useState("");
	const { token, id } = props;
	const [showPasswordOld, setShowPasswordOld] = React.useState(false);
	const [showPassword, setShowPassword] = React.useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

	const [openSnack, setOpenSnack] = React.useState(false);

	const classes = useStyles();

	const handleShowPasswordOld = () => {
		setShowPasswordOld((prevShowPassword) => !prevShowPassword);
	};
	const handleShowPassword = () => {
		setShowPassword((prevShowPassword) => !prevShowPassword);
	};
	const handleShowConfirmPassword = () => {
		setShowConfirmPassword((prevShowPassword) => !prevShowPassword);
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		const data = new FormData(event.currentTarget);
		setActualPasswordError(false);
		setActualPasswordErrorMessage("");
		setConfirmPasswordError(false);
		setConfirmPasswordErrorMessage("");

		agentChangePassword(token, data.get("password"), data.get("newpassword"), (res) => {
			if (!res.error) {
				setOpenSnack(true);
			} else {
				setActualPasswordError(true);
				setActualPasswordErrorMessage(res.message);
			}
		});
	};
	const validateInputs = () => {
		const newpassword = document.getElementById("newpassword");
		const confirmpassword = document.getElementById("confirmpassword");
		let isValid = true;
		if (newpassword !== confirmpassword) {
			setConfirmPasswordError(true);
			setConfirmPasswordErrorMessage("Wrong confirmation password.");
			isValid = false;
		}

		return isValid;
	};

	return (
		<Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
			{/* cards */}
			<Typography component="h2" variant="h6" sx={{ mb: 2 }}>
				Change Password
			</Typography>
			<Grid container columns={12}>
				<Grid size={{ xs: 12, md: 12, lg: 12 }}>
					<Card variant="outlined">
						<Box
							component="form"
							onSubmit={handleSubmit}
							noValidate
							sx={{
								display: "flex",
								flexDirection: "column",
								width: "100%",
								gap: 2,
							}}
						>
							<FormControl>
								<FormLabel htmlFor="password">Old Password</FormLabel>
								<TextField
									error={actulPasswordError}
									helperText={acutualPasswordErrorMessage}
									name="password"
									placeholder="••••••"
									type="password"
									id="password"
									autoComplete="current-password"
									required
									fullWidth
									variant="outlined"
									color={actulPasswordError ? "error" : "primary"}
								/>
							</FormControl>
							<FormControl>
								<FormLabel htmlFor="newpassword">New Password</FormLabel>
								<TextField
									//error={passwordError}
									//helperText={passwordErrorMessage}
									name="newpassword"
									placeholder="••••••"
									type="password"
									id="newpassword"
									//autoComplete="current-newpassword"
									required
									fullWidth
									variant="outlined"
									color={false ? "error" : "primary"}
								/>
							</FormControl>
							<FormControl>
								<FormLabel htmlFor="confirmpassword">Confirm Password</FormLabel>
								<TextField
									error={confirmPasswordError}
									helperText={confirmPasswordErrorMessage}
									name="confirmpassword"
									placeholder="••••••"
									type="password"
									id="confirmpassword"
									//autoComplete="current-password"
									required
									fullWidth
									variant="outlined"
									color={confirmPasswordError ? "error" : "primary"}
								/>
							</FormControl>
							<Button type="submit" fullWidth variant="contained" onClick={validateInputs}>
								Change
							</Button>
						</Box>
					</Card>

					<Snackbar
						anchorOrigin={{
							vertical: "center",
							horizontal: "center",
						}}
						ContentProps={{
							"aria-describedby": "message-id",
							className: classes.snackbarStyleViaContentProps,
						}}
						open={openSnack}
						onClose={() => setOpenSnack(false)}
						autoHideDuration={4000}
						message="Password changed"
						sx={{ backgroundColor: "green" }}
					/>
				</Grid>
			</Grid>
			<Copyright sx={{ my: 4 }} />
		</Box>
	);
};

export default ChangePassword;
